import React, { useEffect, useRef, useState } from "react";
import { Flex, Space, Typography, Button, Tooltip, Skeleton } from "antd";
const { Text, Title } = Typography;
import {
  ReloadOutlined,
  DisconnectOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { disconnectWhatsappChannel } from "../../../../reduxToolkit/channelSlice";
import { useSelector } from "react-redux";

const WhatsappNumbersHeader = ({ onSync }) => {
  const dispatch = useDispatch();
  const { currentBrand } = useSelector((state) => state.app);
  const {
    businessProfile,
    whatsappBusinessNumbersListLoading,
    getBusinessProfileLoading,
  } = useSelector((state) => state.Channel);
  const brandId = currentBrand?.brand_id;
  const [syncCooldown, setSyncCooldown] = useState(0);
  const cooldownKey = "whatsapp_sync_cooldown";
  const intervalRef = useRef();

  useEffect(() => {
    const checkCooldown = () => {
      const cooldownTimestamp = localStorage.getItem(cooldownKey);
      if (cooldownTimestamp) {
        const now = Date.now();
        const remaining = Math.max(
          0,
          60 - Math.floor((now - Number(cooldownTimestamp)) / 1000),
        );
        setSyncCooldown(remaining);
        if (remaining > 0 && !intervalRef.current) {
          intervalRef.current = setInterval(() => {
            const newRemaining = Math.max(
              0,
              60 -
                Math.floor(
                  (Date.now() - Number(localStorage.getItem(cooldownKey))) /
                    1000,
                ),
            );
            setSyncCooldown(newRemaining);
            if (newRemaining <= 0) {
              clearInterval(intervalRef.current);
              intervalRef.current = null;
              localStorage.removeItem(cooldownKey);
            }
          }, 1000);
        }
      }
    };
    checkCooldown();
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  const handleSyncClick = () => {
    localStorage.setItem(cooldownKey, Date.now().toString());
    setSyncCooldown(60);
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        const newRemaining = Math.max(
          0,
          60 -
            Math.floor(
              (Date.now() - Number(localStorage.getItem(cooldownKey))) / 1000,
            ),
        );
        setSyncCooldown(newRemaining);
        if (newRemaining <= 0) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          localStorage.removeItem(cooldownKey);
        }
      }, 1000);
    }
    onSync();
  };

  return (
    <div className="bg-white rounded-xl px-4 py-3 shadow-sm">
      <Flex justify="space-between" align="center">
        <Flex align="center" gap="middle">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="whatsapp"
            className="w-12 h-12 rounded-full"
          />
          <Space direction="vertical" size={0}>
            <Flex align="center" gap="small">
              {getBusinessProfileLoading ? (
                <div style={{ minWidth: 220 }}>
                  <Skeleton
                    active
                    paragraph={{ rows: 1, width: "60%" }}
                    title={{ width: "80%" }}
                  />
                  <Skeleton.Input
                    active
                    size="small"
                    style={{ width: 180, marginTop: 8 }}
                  />
                </div>
              ) : (
                <>
                  <Title level={5} style={{ margin: 0 }}>
                    {businessProfile?.whatsapp_business_account_name}
                  </Title>
                  {businessProfile?.is_whatsapp_business_account_verified && (
                    <div className="text-blue-500 text-xl">
                      <CheckCircleOutlined />
                    </div>
                  )}
                </>
              )}
            </Flex>
            <Text type="secondary">
              WhatsApp Account ID:{" "}
              {businessProfile?.whatsapp_business_account_id}
            </Text>
          </Space>
        </Flex>

        <Space>
          <Tooltip
            title={
              currentBrand?.brand_mode === 'test'
                ? "You can't sync in test mode"
                : syncCooldown > 0
                ? `Sync available in ${syncCooldown}s`
                : "Sync WhatsApp Numbers"
            }
          >
            <Button
              disabled={whatsappBusinessNumbersListLoading || syncCooldown > 0 || currentBrand?.brand_mode === 'test'}
              onClick={handleSyncClick}
              icon={<ReloadOutlined />}
            >
              Sync
            </Button>
          </Tooltip>

          <Tooltip
            title={currentBrand?.brand_mode === 'test' ? "You can't disconnect in test mode" : "Disconnect"}
          >
            <Button
              icon={<DisconnectOutlined />}
              disabled={whatsappBusinessNumbersListLoading || currentBrand?.brand_mode === 'test'}
              onClick={() => {
                if (currentBrand?.brand_mode !== 'test') {
                  dispatch(disconnectWhatsappChannel(brandId));
                }
              }}
              danger
            >
              Disconnect
            </Button>
          </Tooltip>
        </Space>
      </Flex>
    </div>
  );
};

export default WhatsappNumbersHeader;
